import { Grid, GridItem, Skeleton } from '@chakra-ui/react'
import { DashboardCard } from './Dashboard.DashboardCard'

/**
 *
 * @returns JSX.Element
 */
export default function DashboardSkeleton() {
  return (
    <Grid templateColumns={{ base: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)', lg: 'repeat(12, 1fr)' }} gap={8} rowGap={16}>
      <GridItem colSpan={3}>
        <DashboardCard as={Skeleton} />
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard as={Skeleton} />
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard as={Skeleton} />
      </GridItem>
      <GridItem colSpan={3}>
        <DashboardCard as={Skeleton} />
      </GridItem>
      <GridItem colSpan={{ base: 3, md: 6, lg: 12 }}>
        <DashboardCard as={Skeleton} position="relative" overflow="hidden" />
      </GridItem>
    </Grid>
  )
}
